import React, { useEffect, useState, useRef } from 'react';
import Blanks from './blanks.jsx';
import './plans.css'
import Wbs2iframerow from '../wbs2iframe-row.jsx';
import SubmitDocumentsRequestiframe from './SubmitDocumentsRequestiframe.jsx';
import SubmitProgressClaimIframe from './SubmitProgressClaimiframe.jsx';
import InitiatePaymentIframe from './InitiatePaymentIframe.jsx';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars } from '@fortawesome/free-solid-svg-icons';
// import $ from 'jquery';
import { useLocation } from 'react-router-dom';
import PlansIframeList from './PlansIframeLists.jsx';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import RVWiframe from './RVWiframe.jsx';
import ProcurementRequest from './procurementRequest.jsx';
import { showToast } from '../toastUtils';
import UpdateProjectDetails from './updateProjectDetails.jsx';
import ProcurementCreateContract from './ProcurementCreateContract.jsx';
import ProcurementRequestConsultant from './ProcurementRequestConsultant.jsx';
import FullscreenLoader from '../FullscreenLoader';
import ProcurementCreateContractConsultant from './ProcurementCreateContractConsultant.jsx';
import { queuedApiFetch, apiFetch } from '../api';

const MySwal = withReactContent(Swal);
const accountId = localStorage.getItem('accountId');
const formData = new FormData();
// formData.append('key1', 'value1');
// formData.append('key2', 'value2');

function Plans() {
  const [activeSub1, setActiveSub1] = useState(0);
  const [activeSub2, setActiveSub2] = useState(null);
  const location = useLocation();

  //new code updations
  const getUserDetails = localStorage.getItem('userDetails');
  const userDetails = getUserDetails ? JSON.parse(getUserDetails) : '';
  const userId = userDetails ? userDetails.id : '';
  const userName = userDetails ? userDetails.name : '';

  const getUserAccess = userDetails ? userDetails.access_level : '';
  const [userCompany, setUserCompany] = useState();
  const getUserCompanyDetails = userCompany;
  const getUserEmail = localStorage.getItem('userEmail');
  const [userPermission, setUserPermission] = useState();
  //const [userRoleManual, setUserRolesManual] = useState();
  const [userRoleManual, setUserRolesManual] = useState([]);
  const [loading, setLoading] = useState(true);
  const [proj_access_level, setProjAccessLevel] = useState(false);
  // console.log('user Role',userRoleManual);
  // console.log('user Permission',userPermission);
  // console.log('user Company',getUserCompanyDetails);
  let parametervalue;
  // console.log('user Company Name', getUserCompanyDetails);

  //Parameter passing
  if (getUserCompanyDetails === "NUS") {
    parametervalue = 1;
  } else {
    parametervalue = 0;
  }




  // const { projectName } = location.state || {};
  const getProjectDetails = localStorage.getItem('projectDetails');
  const selectedProjectDetail = JSON.parse(getProjectDetails);
  const projectName = selectedProjectDetail.projectName;
  const defaultProjectNumber = selectedProjectDetail.projectNumber;

  // let p_access = selectedProjectDetail?.Proj_Access?.proj_access_level;
  // let p_roles = selectedProjectDetail?.Proj_Access?.proj_role.join(", ");

  //  let p_access = false;
  // let p_roles = '';

  // let qs_params = `nususer=${parametervalue}&project_admin=${(p_access) ? 1 : 0}&project_roles=${p_roles}`;

  // ----------------- QS PARAMS BUILDER -----------------
  const qs_params = React.useMemo(() => {
    const p_access = proj_access_level ? 1 : 0;
    const p_roles = userRoleManual.length > 0 ? userRoleManual.join(', ') : '';
    let proj_name = selectedProjectDetail?.projectName;
    return `nususer=${parametervalue}&project_admin=${p_access}&project_roles=${encodeURIComponent(p_roles)}&project_name=${proj_name}`;
  }, [parametervalue, proj_access_level, userRoleManual]);

  const urnlist = selectedProjectDetail.URN_List;
  const [activeButton, setActiveButton] = useState('updateProjectDetails');
  const InitiateCPRSIframe = `https://acc.autodesk.com/build/forms/projects/${defaultProjectNumber}/field-reports/a926cad1-f598-59dc-8df8-24e07f8eafa9/reports/44de0d37-e6f8-43e0-8ac5-d6d49e8d44b4?${qs_params}&menu=Planning_Initiate CPRS`;
  const ConsultantCreateContractIframe = `https://acc.autodesk.com/cost/cost/projects/${defaultProjectNumber}/contracts?${qs_params}&menu=Procurement Consultant_Create Contract`;
  const ContractorCreateContractIframe = `https://acc.autodesk.com/cost/cost/projects/${defaultProjectNumber}/contracts?${qs_params}&menu=Procurement Contractor_Create Contract`;
  const DesignReviewIframe = `https://acc.autodesk.com/docs/reviews/projects/${defaultProjectNumber}?pageIndex=1&sort=-sequenceId&${qs_params}&menu=Design Development_Design Review`;
  const RequestApprovalIframe = `https://acc.autodesk.com/build/forms/projects/${defaultProjectNumber}/field-reports/253dccad-fd18-57a0-8b93-a714c54bfee1/reports/d51983df-04dd-4cbc-afff-00f87bd83c86?${qs_params}&menu=Design Development_Estimated Cost Approval_Request Approval`;
  const UpdateContractIframe = `https://acc.autodesk.com/cost/cost/projects/${defaultProjectNumber}/contracts?${qs_params}&menu=Design Development_Estimated Cost Approval_Update Contract`;
  const CloseProjectIframe = `https://acc.autodesk.com/build/forms/projects/${defaultProjectNumber}/field-reports/db6d3e00-b3fe-5fcc-ad1f-6a547aa12788/reports/60bd89a1-8a67-4bbe-a8bb-f094d7f714b2?${qs_params}&menu=Post Construction_Close Project`;
  const ProcurementTermIframe = `https://acc.autodesk.com/build/forms/projects/${defaultProjectNumber}/field-reports/b237c3a6-dcd9-5dc4-8cf1-c6fbe4d58702/reports/d29e3cbc-79c8-413d-b237-284e4a10b7ca?${qs_params}`;
  const ProcurementOpenIframe = `https://acc.autodesk.com/build/forms/projects/${defaultProjectNumber}/field-reports/41e5442c-eacd-5209-9b3d-4164fa2f70d5/reports/b768ea08-d035-45e7-8a5c-fe9d2d112db7?${qs_params}`;
  const ProcurementContractTermIframe = `https://acc.autodesk.com/build/forms/projects/${defaultProjectNumber}/field-reports/eccfa3b1-ae1f-5aff-96de-cb9e6a244adb/reports/45eeeffa-5c29-4ee5-8e16-51727e99f496?${qs_params}`;
  const ProcurementContractOpenIframe = `https://acc.autodesk.com/build/forms/projects/${defaultProjectNumber}/field-reports/41e5442c-eacd-5209-9b3d-4164fa2f70d5/reports/b768ea08-d035-45e7-8a5c-fe9d2d112db7?${qs_params}`;
  const DesignSubmittalIframe = `https://acc.autodesk.com/build/submittals/projects/${defaultProjectNumber}/items?sort=customIdentifier%20desc&${qs_params}&menu=Design Development_Design Submittal`;
  const CommencementFormIframe = `https://acc.autodesk.com/build/forms/projects/${defaultProjectNumber}/field-reports/3da77acd-271a-5ac9-900d-9d3a7e2de4e0/reports/d10f5c29-7a67-4ae7-b08e-5351452d90ef?${qs_params}&menu=Construction_Project Commencement_Commencement Form`;
  const SubmitDocumentsRequestIframe = ``;
  const ConstructionSubmittalIframe = `https://acc.autodesk.com/build/submittals/projects/${defaultProjectNumber}/items?sort=customIdentifier%20desc&${qs_params}&menu=Construction_Construction Submittal`;
  const ApplyForRVWIframe = ``;
  const ContractVariationIframe = ``;
  const InitiateHandoverIframe = ``;
  const GenerateDefectListIframe = `https://acc.autodesk.com/build/issues/projects/${defaultProjectNumber}/issues?${qs_params}&menu=Handover_Generate defect list`;
  const SubmitFormIframe = ``;
  const ConsultantApprovalIframe = `https://acc.autodesk.com/build/forms/projects/${defaultProjectNumber}/field-reports/0314f9b4-5084-57db-bef3-391a4fcacbd0/reports/0db7ca22-2b94-48ab-a909-0cdb98171c56?${qs_params}&menu=Construction_Progress claims_Consultant Approval`;
  // const SubmitProgressClaimIframe = ``;
  const ProcurmentRequestIframe = ``;
  const ContractProcurementRequestIframe = ``;
  // const InitiatePaymentIframe = ``;
  const MeetingsIframe = `https://acc.autodesk.com/build/meetings/projects/${defaultProjectNumber}?${qs_params}`;
  const TransmittalIframe = `https://acc.autodesk.com/docs/transmittals/projects/${defaultProjectNumber}?index=1&sort=-sequenceId&${qs_params}`;
  const HandoverFormIframe = `https://acc.autodesk.com/build/forms/projects/${defaultProjectNumber}/field-reports/58c06c04-3ac1-58b5-bd94-f85e1d2d4128/reports/37384312-b117-4763-bdb0-30b2734e89b3?${qs_params}&menu=Handover_Handover Form`;
  const CorrespondenceIframe = `https://acc.autodesk.com/build/correspondence/projects/${defaultProjectNumber}?${qs_params}`;
  const WarrantyProceedIframe = ``;
  const CPRS_PROCEED = `https://acc.autodesk.com/build/forms/projects/${defaultProjectNumber}/field-reports/a926cad1-f598-59dc-8df8-24e07f8eafa9/reports/44de0d37-e6f8-43e0-8ac5-d6d49e8d44b4?${qs_params}`;

  //Form Template names
  const t_cprs_proceed = 'CPRS Approval';
  const t_req_approval = 'Cost Estimation & Approval';
  const t_proj_comncmnt = 'Project Commencement';
  const t_consult_appr = 'Progress Claim - For Consultant Approval';
  const t_ho_form = 'Signing off for Handover';
  const t_close_project = 'Project Closing';



  // const getUserCompanyDetails='NUS';
  // const userPermission=1;
  //procurementRequest.jsx
  // const t_cons_proreq_open='Open Tender Document Review & Sign Off';
  // const t_cons_proreq_term='Term Consultant - Procurement Request';
  // const t_cont_proreq_open='Open Tender Document Review & Sign Off';
  // const t_cont_proreq_term='Term Contractor - Procurement Request';



  //RVWiframe.jsx
  // const t_apply_new_rvw='RVW';
  // const t_apply_ipa='RVW (IPA)';
  // const t_apply_ss_rvw='RVW';


  //SubmitDocumentRequestiframe.jsx
  // const t_site_ho_cont='Site Handover to Contractor';
  // const t_site_uti_plan='Site Utilization Plan';
  // const t_high_imp_work='High Impact Work';
  // const t_inst_req='Installation Request';
  // const t_pir_form='PIR';
  // const t_proj_checklist='Project Checklist';
  // const t_cons_appraisal='Consultant appraisal form';
  // const t_cont_appraisal='Contractor appraisal form';

  // useEffect(()=>{
  //   getProjectURN()
  // },[])

  // const getProjectURN = async () => {
  //   const requestOptions = {
  //     method: 'GET',
  //     //headers: new Headers({ 'ngrok-skip-browser-warning': '69420' })
  //   };  
  //   try {
  //     const response = await fetch(`https://nuscpmsurn-hxh2hcb5bpfxahep.southeastasia-01.azurewebsites.net/urn/get_project_urnlist?proj_number=${defaultProjectNumber}`, requestOptions);
  //     const data = await response;      
  //     if (data.apistatus.Status_Code === 200 && data.apistatus.Status_Description.toLowerCase() === 'success') {        
  //       const urns = data.data;
  //       console.log('urns....',urns);

  //       // this.setState({ projectURNs: urns });
  //     }
  //   } catch (error) {
  //     console.error('Error fetching data:', error);
  //   } finally {      
  //   }    
  // };

  const fetchUserCompany = async () => {
    const requestOptions = {
      method: 'GET',
      //headers: new Headers({ 'ngrok-skip-browser-warning': '69420' })
    };
    try {
      // const response = await queuedApiFetch(`/user/getuserprofile?emailid=${getUserEmail}`, requestOptions);
      const response = await queuedApiFetch(`/user/getuserprofile?emailid=${getUserEmail}`, requestOptions);
      const data = await response;

      if (data.apistatus.Status_Code === 200 && data.apistatus.Status_Description.toLowerCase() === 'success') {
        setUserCompany(data.data.company_name);
        setUserPermission(data.data.access_level);
        //setUserCompany('BIMAGE');
        //setUserPermission('project_user'); 
        // setUserCompany('UAT Maincon A');
        //setUserPermission('project_admin');
      }
    } catch (error) {
      console.error('Error fetching data:', error);
    } finally {
      //setLoading(false); // End loading
    }
  }

  const fetchUserRole = async () => {
    if (!userId || !defaultProjectNumber) {
      return;
    }
    const requestOptions = {
      method: 'GET',
      //headers: new Headers({ 'ngrok-skip-browser-warning': '69420' })
    };
    try {
      // const response = await queuedApiFetch(`/project/get_project_role?userid=${userId}&projectid=${defaultProjectNumber}`, requestOptions);
      const response = await queuedApiFetch(`/project/get_project_role?userid=${userId}&projectid=${defaultProjectNumber}`, requestOptions);
      const data = await response;

      if (data.apistatus.Status_Code === 200 && data.apistatus.Status_Description.toLowerCase() === 'success') {
        // console.log(data.data); 
        //data.data[0]="Consultant";
        setUserRolesManual(data.data || []);
        setProjAccessLevel(data.access_level || false);

        //setUserRolesManual('Consultant');
        //setUserRolesManual(['Contractor']);
        //setUserRolesManual('Admin & Contract (AC)');
      }
    } catch (error) {
      console.error('Error fetching data:', error);
    } finally {
      setLoading(false); // End loading
    }
  }

  //   useEffect(() => {
  //     const fetchData = async () => {
  //         try {
  //             await fetchUserCompany();
  //         } catch (error) {
  //             console.error("Error fetching data:", error);
  //         }
  //     };
  //     fetchData();
  // }, []);

  const fetchData = async () => {
    try {
      await fetchUserCompany();
      await fetchUserRole();

    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    if (loading) return;
    //const timer = setTimeout(() => {
    //console.log("Running with updated data:", qs_params);
    const getSearch = location.search;

    if (getSearch.includes('submit-document-request')) {
      setActiveSub1(4);
      handleComponentChange(SubmitDocumentsRequestIframe, 'SubmitDocumentsRequest');
    } else if (getSearch.includes('submit-progress-claim')) {
      setActiveSub1(4);
      setActiveSub2(3);
      handleComponentChange(SubmitProgressClaimIframe, 'SubmitProgressClaim');
    } else if (getSearch.includes('apply-rvw')) {
      setActiveSub1(4);
      setActiveSub2(2);
      handleComponentChange(ApplyForRVWIframe, 'ApplyForRVW');
    } else if (getSearch.includes('submit-form')) {
      setActiveSub1(6);
      handleComponentChange(SubmitFormIframe, 'SubmitForm');
    } else if (getSearch.includes('update-project-details')) {
      setActiveSub1(0);
      handleComponentChange('', 'updateProjectDetails');
    } else if (getSearch.includes('procurement-request')) {
      setActiveSub1(1);
      handleComponentChange(ProcurmentRequestIframe, 'ConsultantProcurementRequest');
    } else if (getSearch.includes('consultant-create-contract')) {
      setActiveSub1(1);
      handleComponentChange('', 'ConsultantCreateContract');
    } else if (getSearch.includes('contract-procurement')) {
      setActiveSub1(3);
      handleComponentChange(ContractProcurementRequestIframe, 'ContractProcurementRequest');
    } else if (getSearch.includes('contractor-create-contract')) {
      setActiveSub1(3);
      handleComponentChange('', 'ContractorCreateContract');
    } else if (getSearch.includes('initiate-cprs')) {
      setActiveSub1(0);
      handleComponentChange(InitiateCPRSIframe, 'InitiateCPRS');
      cprsPopup();
    } else if (getSearch.includes('design-review')) {
      setActiveSub1(2);
      handleComponentChange(DesignReviewIframe, 'DesignReview');
      designReviewPopup();
    } else if (getSearch.includes('request-approval')) {
      setActiveSub1(2);
      setActiveSub2(0);
      handleComponentChange(RequestApprovalIframe, 'RequestApproval');
      window.submitform(t_req_approval, formData, 'Design Development_Estimated Cost Approval_Request Approval');
    } else if (getSearch.includes('commencement-form')) {
      setActiveSub1(4);
      setActiveSub2(1);
      handleComponentChange(CommencementFormIframe, 'CommencementForm');
      window.submitform(t_proj_comncmnt, formData, 'Construction_Project Commencement_Commencement Form');
    } else if (getSearch.includes('cert-sub-comp')) {
      console.log("cert-sub-comp -> qsparams", qs_params);
      setActiveSub1(5);
      handleComponentChange('', 'CertOfSubstantialCompletion');
      subsCompletionPopup();
    } else if (getSearch.includes('final-comp-cert')) {
      console.log("final-comp-cert -> qsparams", qs_params);
      setActiveSub1(5);
      handleComponentChange('', 'FinalCompletionCert');
      finalCompletionPopup();
    } else if (getSearch.includes('warrenty-built-om')) {
      setActiveSub1(5);
      handleComponentChange('', 'WarrantyAsbuiltOM');
      warrantyPopup();
    } else if (getSearch.includes('handover-form')) {
      setActiveSub1(5);
      handleComponentChange(HandoverFormIframe, 'HandoverForm');
      window.submitform(t_ho_form, formData, 'Handover_Handover Form');
    } else if (getSearch.includes('close-project')) {
      setActiveSub1(6);
      handleComponentChange(CloseProjectIframe, 'CloseProject');
      window.submitform(t_close_project, formData, 'Post Construction_Close Project');
    }
    // }, 500);
    // return () => clearTimeout(timer);
  }, [loading, location, qs_params]);


  const [currentComponent, setCurrentComponent] = useState(!location.search && <UpdateProjectDetails />);
  const [change, nextchange] = useState('')
  let handchanges = (Change) => {
    nextchange(Change);
  }

  const [showOptions, setShowOptions] = useState(false);
  const optionsPopupRef = useRef(null);

  // Toggle visibility of options popup
  const toggleOptions = (event) => {
    event.stopPropagation();
    setShowOptions(prevShowOptions => !prevShowOptions);
  };
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (optionsPopupRef.current && !optionsPopupRef.current.contains(event.target)) {
        setShowOptions(false);
      }
    };

    document.addEventListener('click', handleClickOutside);
    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, []);

  const toggleSub1 = (index) => {
    setActiveSub1((prev) => (prev === index ? null : index));
  };
  const toggleSub2 = (index) => {
    setActiveSub2((prev) => (prev === index ? null : index));
  };


  const handleComponentChange = async (url, buttonId) => {
    setActiveButton(buttonId);
    if (buttonId == 'SubmitDocumentsRequest' || buttonId == 'SubmitForm') {
      setCurrentComponent(<SubmitDocumentsRequestiframe buttonId={buttonId} />)
    } else if (buttonId == 'ContractorCreateContract') {
      setCurrentComponent(<ProcurementCreateContract buttonId={buttonId} />)
    } else if (buttonId == 'ConsultantCreateContract') {
      setCurrentComponent(<ProcurementCreateContractConsultant buttonId={buttonId} />)
    } else if (buttonId == 'updateProjectDetails') {
      setCurrentComponent(<UpdateProjectDetails />)
    } else if (buttonId == 'SubmitProgressClaim') {
      setCurrentComponent(<SubmitProgressClaimIframe />)
    } else if (buttonId == 'InitiatePayment') {
      setCurrentComponent(<InitiatePaymentIframe />)
    }
    else if (buttonId == 'ApplyForRVW') {
      setCurrentComponent(<RVWiframe />)
    } else if (buttonId == 'ConsultantProcurementRequest') {
      setCurrentComponent(<ProcurementRequestConsultant menuName={buttonId} ProcurementTermIframe={ProcurementTermIframe} ProcurementOpenIframe={ProcurementOpenIframe} ProcurementContractTermIframe={ProcurementContractTermIframe} ProcurementContractOpenIframe={ProcurementContractOpenIframe} />)
    } else if (buttonId == 'ContractProcurementRequest') {
      setCurrentComponent(<ProcurementRequest menuName={buttonId} ProcurementTermIframe={ProcurementTermIframe} ProcurementOpenIframe={ProcurementOpenIframe} ProcurementContractTermIframe={ProcurementContractTermIframe} ProcurementContractOpenIframe={ProcurementContractOpenIframe} />)
    } else if (buttonId == 'ProjectFiles') {
      const fetchFolderUrl = await getFolderLink();
      if (fetchFolderUrl) {
        const encodedFolderUrl = fetchFolderUrl.replace(/https:(.*)/, (_, rest) => {
          return `https:${rest.replace(/:/g, '%3A')}`;
        });
        setCurrentComponent(
          <PlansIframeList iframeUrl={encodedFolderUrl} />
        );
      } else {
        setCurrentComponent(
          <PlansIframeList iframeUrl="" />
        );
      }
    } else {
      setCurrentComponent(<PlansIframeList iframeUrl={url} />)
    }
  };


  const getFolderLink = async () => {
    const requestOptions = {
      method: 'GET',
      //headers: new Headers({ 'ngrok-skip-browser-warning': '69420' }),
    };

    try {
      const response = await queuedApiFetch(`/project/get_folderlink?accountid=${accountId}&projectid=${defaultProjectNumber}`,
        requestOptions
      );
      const data = await response;
      if (
        data.apistatus.Status_Code === 200 &&
        data.apistatus.Status_Description.toLowerCase() === 'success'
      ) {
        return data.data;
      } else {
        return null;
      }
    } catch (error) {
      console.error('Error fetching data:', error);
      return null;
    }
  };


  const openPopup = () => {
    Swal.fire({
      title: 'Please select the Procurement Type',
      showCancelButton: true,
      confirmButtonText: 'Term',
      cancelButtonText: 'Open',
      showCloseButton: true,
      customClass: {
        confirmButton: 'swal-confirm-btn',
        cancelButton: 'swal-cancel-btn',
      },
    }).then((result) => {
      if (result.isConfirmed) {
        handleComponentChange(ProcurementTermIframe, 'ConsultantProcurementRequest');
        // window.location.replace(ProcurementTermIframe);
        //window.submitform(t_cons_proreq_term,formData);
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        handleComponentChange(ProcurementOpenIframe, 'ConsultantProcurementRequest');
        // window.location.replace(ProcurementOpenIframe);
        //window.submitform(t_cons_proreq_open,formData);
      }
    });
  };

  const openProcurementContractor = () => {
    Swal.fire({
      title: 'Please select the Procurement Type',
      showCancelButton: true,
      confirmButtonText: 'Term',
      cancelButtonText: 'Open',
      showCloseButton: true,
      customClass: {
        confirmButton: 'contractor-swal-confirm-btn',
        cancelButton: 'contractor-swal-cancel-btn',
      },
    }).then((result) => {
      if (result.isConfirmed) {
        handleComponentChange(ProcurementContractTermIframe, 'ContractProcurementRequest');
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        handleComponentChange(ProcurementContractOpenIframe, 'ContractProcurementRequest');
      }
    });
  };

  // const cprsPopup = () => {
  //   Swal.fire({
  //     title: 'Please upload CPRS excel sheet in folder `A` before proceeding',
  //     showCancelButton: true,
  //     confirmButtonText: 'Upload',
  //     cancelButtonText: 'Proceed',
  //     showCloseButton: true,
  //     width: '700px',
  //     customClass: {
  //       confirmButton: 'swal-confirm-btn',
  //       cancelButton: 'swal-cancel-btn',
  //     },
  //   }).then((result) => {
  //     if (result.isConfirmed) {
  //       const CPRS_UPLOAD = `https://acc.autodesk.com/docs/files/projects/${defaultProjectNumber}?folderUrn=${urnlist.ini_cprs_upload}&viewModel=detail&moduleId=folders${parametervalue === 0 ? '&nususer=0' : '&nususer=1'}&menu=Planning_Initiate CPRS`;
  //       window.location.replace(CPRS_UPLOAD);
  //       //window.submitform(CPRS_UPLOAD,formData)
  //     } else if (result.dismiss === Swal.DismissReason.cancel) {
  //       // window.location.replace(CPRS_PROCEED);
  //       // window.submitform(CPRS_PROCEED,formData);
  //       window.submitform(t_cprs_proceed,formData,'Planning_Initiate CPRS');
  //     } 
  //   });
  // };


  // const cprsPopup = () => {
  //   Swal.fire({
  //     title: 'Please upload CPRS Excel or PDF file in folder `A` before proceeding',
  //     showCancelButton: true,
  //     confirmButtonText: 'Upload',
  //     cancelButtonText: 'Proceed',
  //     allowOutsideClick: false,
  //     showCloseButton: true,
  //     width: '700px',
  //     customClass: {
  //       confirmButton: 'swal-confirm-btn',
  //       cancelButton: 'swal-cancel-btn',
  //     },
  //   }).then((result) => {
  //     if (result.isConfirmed) {
  //       // Second popup for file upload
  //       Swal.fire({
  //         title: 'Upload CPRS Excel or PDF File',
  //         html: `
  //           <input type="file" id="cprs-file" className="custom-file-input" accept=".xlsx,.xls,.pdf" />
  //         `,
  //         showCancelButton: true,
  //         confirmButtonText: 'Submit',
  //         cancelButtonText: 'Cancel',
  //         allowOutsideClick: false,
  //         showCloseButton: true,
  //         didOpen: () => {
  //           // Custom styling
  //           const style = document.createElement('style');
  //           style.innerHTML = `
  //             .custom-file-input {
  //               width: 100%;
  //               padding: 12px;
  //               border: 2px solid #ccc;
  //               border-radius: 8px;
  //               font-size: 16px;
  //               cursor: pointer;
  //               box-sizing: border-box;
  //               margin-top: 10px;
  //             }
  //             .custom-file-input:hover {
  //               border-color: #888;
  //             }
  //           `;
  //           document.head.appendChild(style);
  //         },
  //         preConfirm: () => {
  //           const fileInput = document.getElementById('cprs-file');
  //           if (!fileInput.files.length) {
  //             Swal.showValidationMessage('Please select a file before submitting');
  //             return false;
  //           }

  //           const file = fileInput.files[0];
  //           const allowedTypes = [
  //             'application/vnd.ms-excel',
  //             'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  //             'application/pdf'
  //           ];

  //           if (!allowedTypes.includes(file.type)) {
  //             Swal.showValidationMessage('Only Excel or PDF files are allowed');
  //             return false;
  //           }

  //           return file;
  //         },
  //       }).then((uploadResult) => {
  //         if (uploadResult.isConfirmed) {
  //           const file = uploadResult.value;
  //           const fileDetails = {
  //             project_id: defaultProjectNumber, 
  //             Project_name: projectName,
  //             file_name: file.name,
  //             file_path: file,
  //           };

  //           queuedApiFetch(`/funding/file_upload`, {
  //             method: "GET",
  //             headers: {
  //               "Content-Type": "application/json",
  //             },
  //             body: JSON.stringify(fileDetails),
  //           })
  //             .then((res) => {
  //               if (!res.ok) throw new Error("Upload failed");
  //               return res.json();
  //             })
  //             .then((data) => {
  //               console.log("Upload success:", data);
  //               Swal.fire("Upload success", "An error occurred while uploading file details.", "error");
  //             })
  //             .catch((err) => {
  //               console.error("Upload error:", err);
  //               Swal.fire("Upload failed", "An error occurred while uploading file details.", "error");
  //             });
  //         } else if (
  //           uploadResult.dismiss === Swal.DismissReason.cancel ||
  //           uploadResult.dismiss === Swal.DismissReason.close
  //         ) {
  //           cprsPopup(); // Reopen first popup
  //         }
  //       });

  //     } else if (result.dismiss === Swal.DismissReason.cancel) {
  //       window.submitform(t_cprs_proceed, formData, 'Planning_Initiate CPRS');
  //     }
  //   });
  // };

  const cprsPopup = () => {
    Swal.fire({
      title: 'Please upload CPRS Excel or PDF file in folder [SPACE_CPDC_BoT] before proceeding',
      showCancelButton: true,
      confirmButtonText: 'Upload',
      cancelButtonText: 'Proceed',
      allowOutsideClick: false,
      showCloseButton: true,
      width: '700px',
      customClass: {
        confirmButton: 'swal-confirm-btn',
        cancelButton: 'swal-cancel-btn',
      },
    }).then((result) => {
      if (result.isConfirmed) {
        const CPRS_UPLOAD = `https://acc.autodesk.com/docs/files/projects/${defaultProjectNumber}?folderUrn=${urnlist.ini_cprs_upload}&viewModel=detail&moduleId=folders&${qs_params}&menu=Planning_Initiate CPRS`;
        //window.open(CPRS_UPLOAD, '_blank');
        window.location.replace(CPRS_UPLOAD);
        //window.submitform(CPRS_UPLOAD,formData);

        //#region file upload popup
        // // Second popup for file upload
        // Swal.fire({
        //   title: 'Upload CPRS Excel or PDF File',
        //   html: `
        //     <input type="file" id="cprs-file" className="custom-file-input" accept=".xlsx,.xls,.pdf" />
        //   `,
        //   showCancelButton: true,
        //   confirmButtonText: 'Submit',
        //   cancelButtonText: 'Cancel',
        //   allowOutsideClick: false,
        //   showCloseButton: true,
        //   didOpen: () => {
        //     // Custom styling
        //     const style = document.createElement('style');
        //     style.innerHTML = `
        //       .custom-file-input {
        //         width: 100%;
        //         padding: 12px;
        //         border: 2px solid #ccc;
        //         border-radius: 8px;
        //         font-size: 16px;
        //         cursor: pointer;
        //         box-sizing: border-box;
        //         margin-top: 10px;
        //       }
        //       .custom-file-input:hover {
        //         border-color: #888;
        //       }
        //     `;
        //     document.head.appendChild(style);
        //   },
        //   preConfirm: () => {
        //     const fileInput = document.getElementById('cprs-file');
        //     if (!fileInput.files.length) {
        //       Swal.showValidationMessage('Please select a file before submitting');
        //       return false;
        //     }

        //     const file = fileInput.files[0];
        //     const allowedTypes = [
        //       'application/vnd.ms-excel',
        //       'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        //       'application/pdf'
        //     ];

        //     if (!allowedTypes.includes(file.type)) {
        //       Swal.showValidationMessage('Only Excel or PDF files are allowed');
        //       return false;
        //     }

        //     return file;
        //   },
        // }).then((uploadResult) => {
        //   if (uploadResult.isConfirmed) {
        //     const file = uploadResult.value;

        //     // Prepare FormData with file and additional data
        //     const formData = new FormData();
        //     formData.append("project_id", defaultProjectNumber);
        //     formData.append("Project_name", projectName);
        //     formData.append("file_name", file.name);
        //     formData.append("file", file); 

        //    queuedApiFetch(`/funding/file_upload`, {
        //       method: "POST",
        //       body: formData,
        //     })
        //       .then((res) => {
        //         if (!res.ok) throw new Error("Upload failed");
        //         return res.json();
        //       })
        //       .then((data) => {
        //         console.log("Upload success:", data);
        //         Swal.fire("Upload successful", "Your file has been uploaded.", "success");
        //       })
        //       .catch((err) => {
        //         console.error("Upload error:", err);
        //         Swal.fire("Upload failed", "An error occurred while uploading file details.", "error");
        //       });

        //   } else if (
        //     uploadResult.dismiss === Swal.DismissReason.cancel ||
        //     uploadResult.dismiss === Swal.DismissReason.close
        //   ) {
        //     cprsPopup(); // Reopen first popup
        //   }

        // });
        //#endregion

      } else if (result.dismiss === Swal.DismissReason.cancel) {
        window.submitform(t_cprs_proceed, formData, 'Planning_Initiate CPRS');
      }
    });
  };





  //   const submitForm = (actionUrl) => {
  //     const form = document.createElement('form');
  //     form.method = 'GET'; // or 'GET' if needed
  //     form.action = actionUrl;
  //     document.body.appendChild(form);
  //     form.submit();
  // };
  // const submitForm = (template_name, formData, menu) => {
  //   const form = document.createElement('form');
  //   form.method = 'POST';
  //   //form.action = actionUrl;
  //   form.action = `${process.env.REACT_APP_BACKEND_URL}/form_template/form_post`;
  //    formData.append('account_id', accountId);
  //    formData.append('project_id', defaultProjectNumber);
  //    //added 2 parameters for the url
  //    formData.append('menu', menu);
  //    formData.append('nususer', parametervalue);
  //   formData.append('template_name', template_name);
  //   // form.enctype = 'multipart/form-data'; // Required for file uploads
  //   // Append FormData fields as hidden inputs
  //   for (const [key, value] of formData.entries()) {
  //       const input = document.createElement('input');
  //       input.type = 'hidden';
  //       input.name = key;
  //       input.value = value;
  //       form.appendChild(input);
  //   }
  //   document.body.appendChild(form);
  //   form.submit();
  // };

  const designReviewPopup = () => {
    Swal.fire({
      title: 'Please upload files in folder [Design Review & Sign-off] before proceeding',
      showCancelButton: true,
      confirmButtonText: 'Upload',
      cancelButtonText: 'Proceed',
      showCloseButton: true,
      width: '600px',
      customClass: {
        confirmButton: 'swal-confirm-btn',
        cancelButton: 'swal-cancel-btn',
      },
    }).then((result) => {
      if (result.isConfirmed) {
        const designReviewUpload = `https://acc.autodesk.com/docs/files/projects/${defaultProjectNumber}?folderUrn=${urnlist.des_review_upload}&viewModel=detail&moduleId=folders&${qs_params}&menu=Design Development_Design Review`;
        //window.location.replace(designReviewUpload);
        window.open(designReviewUpload, '_blank');
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        const designReviewProceed = `https://acc.autodesk.com/docs/reviews/projects/${defaultProjectNumber}?pageIndex=1&sort=-sequenceId&${qs_params}&menu=Design Development_Design Review`;
        //window.location.replace(designReviewProceed);
        window.open(designReviewProceed, '_blank');
      }
    });
  };

  const warrantyPopup = () => {
    Swal.fire({
      title: 'Please upload files in folder [BIM, As-built, O&M and Warranties] before proceeding',
      showCancelButton: true,
      confirmButtonText: 'Upload',
      cancelButtonText: 'Proceed',
      showCloseButton: true,
      width: '700px',
      customClass: {
        confirmButton: 'swal-confirm-btn',
        cancelButton: 'swal-cancel-btn',
      },
    }).then((result) => {
      const WarrantyUploadIframe = `https://acc.autodesk.com/build/files/projects/${defaultProjectNumber}?folderUrn=${urnlist.war_built_om}&viewModel=detail&moduleId=folders&${qs_params}&menu=Handover_Warranty/Asbuilt/OM`;
      const WarrentyProceedUrl = `https://acc.autodesk.com/docs/reviews/projects/${defaultProjectNumber}?pageIndex=1&sort=-sequenceId&${qs_params}&menu=Handover_Warranty/Asbuilt/OM`
      if (result.isConfirmed) {
        //window.location.replace(WarrantyUploadIframe);
        window.open(WarrantyUploadIframe, '_blank');
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        //window.location.replace(WarrentyProceedUrl);
        window.open(WarrentyProceedUrl, '_blank');
      }
    });
  };


  const finalCompletionPopup = () => {
    MySwal.fire({
      title: '',
      html: `
              <div class="popup-container">        
            <div class="popup-body">            
            <div class="popup-field">
                <label for="certDate">Date of Submission *</label>
                <input style="width: 190px; border-radius: 0;" id="certDate" type="date" class="popup-input">
              </div>                   
            </div>
          </div>
            `,
      showCancelButton: true,
      confirmButtonText: 'Submit',
      cancelButtonText: 'Cancel',
      focusConfirm: false,
      customClass: {
        popup: 'custom-popup',
        cancelButton: 'cancel-button',
        confirmButton: 'bond-confirm-button',
        actions: 'custom-actions',
      },
      reverseButtons: false,
      allowOutsideClick: false,
      preConfirm: async () => {
        const certDate = document.getElementById('certDate').value;
        if (!certDate) {
          Swal.showValidationMessage('Please fill out all required fields');
          return false;
        }

        try {
          Swal.showLoading();
          const requestOptions = {
            method: 'GET',
            // headers: {
            //   'ngrok-skip-browser-warning': '69420',
            // },
          };
          const response = await queuedApiFetch(`/handover/update_project_cert?project_id=${defaultProjectNumber}&cert_type=final&cert_date=${certDate}`, requestOptions);
          const result = await response;
          if (result.apistatus.Status_Code === 200 && result.apistatus.Status_Description.toLowerCase() === 'success') {
            const FinalCert = `https://acc.autodesk.com/build/files/projects/${defaultProjectNumber}?folderUrn=${urnlist.final_cert}&viewModel=detail&moduleId=folders&${qs_params}&menu=Handover_Final Completion Cert`;
            window.location.href = FinalCert;
          } else {
            Swal.showValidationMessage(result.apistatus.Status_Description || 'Error occurred. Please try again.');
            return false;
          }
        } catch (error) {
          console.error('Error saving data:', error);
          Swal.showValidationMessage('Something went wrong. Please try again.');
          return false;
        }
      },
    }).then((result) => {
      if (result.isConfirmed) {
        console.log('Project created successfully!');
      }
    }).catch((errorMessage) => {
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: errorMessage,
      });
    });
  };


  const subsCompletionPopup = () => {
    MySwal.fire({
      title: '',
      html: `
              <div class="popup-container">        
            <div class="popup-body">            
            <div class="popup-field">
                <label for="certDate">Date of Submission *</label>
                <input style="width: 190px; border-radius: 0;" id="certDate" type="date" class="popup-input">
              </div>                   
            </div>
          </div>
            `,
      showCancelButton: true,
      confirmButtonText: 'Submit',
      cancelButtonText: 'Cancel',
      focusConfirm: false,
      customClass: {
        popup: 'custom-popup',
        cancelButton: 'cancel-button',
        confirmButton: 'bond-confirm-button',
        actions: 'custom-actions',
      },
      reverseButtons: false,
      allowOutsideClick: false,
      preConfirm: async () => {
        const certDate = document.getElementById('certDate').value;
        if (!certDate) {
          Swal.showValidationMessage('Please fill out all required fields');
          return false;
        }

        try {
          Swal.showLoading();
          const requestOptions = {
            method: 'GET',
            // headers: {
            //   'ngrok-skip-browser-warning': '69420',
            // },
          };
          const response = await queuedApiFetch(`/handover/update_project_cert?project_id=${defaultProjectNumber}&cert_type=subs&cert_date=${certDate}`, requestOptions);
          const result = await response;
          if (result.apistatus.Status_Code === 200 && result.apistatus.Status_Description.toLowerCase() === 'success') {
            const SubsCert = `https://acc.autodesk.com/build/files/projects/${defaultProjectNumber}?folderUrn=${urnlist.subs_cert}&viewModel=detail&moduleId=folders&${qs_params}&menu=Handover_Cert of Substantial Completion`;
            window.location.href = SubsCert;
          } else {
            Swal.showValidationMessage(result.apistatus.Status_Description || 'Error occurred. Please try again.');
            return false;
          }
        } catch (error) {
          console.error('Error saving data:', error);
          Swal.showValidationMessage('Something went wrong. Please try again.');
          return false;
        }
      },
    }).then((result) => {
      if (result.isConfirmed) {
        console.log('Project created successfully!');
      }
    }).catch((errorMessage) => {
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: errorMessage,
      });
    });
  };

  // const openCreateProjectPopup = () => {
  //   MySwal.fire({
  //     title: '<h3>Create Project</h3>',
  //     html: `
  //       <div className="popup-container">
  //         <div className="popup-field">
  //           <label for="projectName">Project Name *</label>
  //           <input id="projectName" type="text" className="popup-input" placeholder="Enter a project name">
  //         </div>

  //         <div className="popup-field">
  //           <label for="projectNumber">Project Number</label>
  //           <input id="projectNumber" type="text" className="popup-input" placeholder="Enter a project number">
  //         </div>

  //         <div className="popup-field">
  //           <label for="account">Account *</label>
  //           <select id="account" className="popup-select">
  //             <option value="" disabled selected>Select an account</option>
  //             <option value="NUS CPMS">NUS CPMS</option>
  //             <option value="ABC Corporation">ABC Corporation</option>
  //           </select>
  //         </div>

  //         <div className="popup-field">
  //           <label for="projectType">Project Type *</label>
  //           <select id="projectType" className="popup-select">
  //             <option value="" disabled selected>Select project type</option>
  //             <option value="Education Facility">Education Facility</option>
  //             <option value="Healthcare Facility">Healthcare Facility</option>
  //           </select>
  //         </div>
  //       </div>
  //     `,
  //     showCancelButton: true,
  //     confirmButtonText: 'Create',
  //     cancelButtonText: 'Cancel',
  //     focusConfirm: false,
  //     customClass: {
  //       popup: 'custom-popup',
  //     },
  //     preConfirm: () => {
  //       // Get input values
  //       const projectName = document.getElementById('projectName').value;
  //       const projectNumber = document.getElementById('projectNumber').value;
  //       const account = document.getElementById('account').value;
  //       const projectType = document.getElementById('projectType').value;

  //       // Validation
  //       if (!projectName || !account || !projectType) {
  //         Swal.showValidationMessage('Please fill out all required fields');
  //         return false;
  //       }

  //       // Return a promise to keep the popup open
  //       return new Promise((resolve, reject) => {
  //         const sendData = {
  //           project_name: projectName,
  //           project_number: projectNumber,
  //           account: account,
  //           project_account: projectType,
  //         };

  //         // Show a loading spinner
  //         Swal.showLoading();

  //         // Make the API call
  //         const requestOptions = {
  //           method: 'POST',
  //           headers: {
  //             'Content-Type': 'application/json',
  //             'ngrok-skip-browser-warning': '69420',
  //           },
  //           body: JSON.stringify(sendData),
  //         };

  //         queuedApiFetch('/project/insertprojectdetails', requestOptions)
  //           .then((response) => response.json())
  //           .then((result) => {
  //             if (
  //               result.apistatus.Status_Code === 200 &&
  //               result.apistatus.Status_Description.toLowerCase() === 'success'
  //             ) {
  //               toast.success('Project Created Successfully', {
  //                 position: 'bottom-center',
  //                 autoClose: 3000,
  //                 hideProgressBar: false,
  //                 closeOnClick: true,
  //                 pauseOnHover: true,
  //                 draggable: true,
  //                 progress: undefined,
  //                 theme: 'colored',
  //               });

  //               // Resolve the promise to close the popup
  //               resolve();
  //             } else {
  //               // Reject to show an error message
  //               reject(result.apistatus.Status_Description);
  //             }
  //           })
  //           .catch((error) => {
  //             console.error('Error saving data:', error);
  //             reject('Something went wrong. Please try again.');
  //           });
  //       });
  //     },
  //   }).then((result) => {
  //     if (result.isConfirmed) {
  //       // Optional: Perform any additional actions after popup closes
  //       console.log('Project created successfully!');
  //     }
  //   }).catch((errorMessage) => {
  //     // Show an error message in the popup
  //     Swal.fire({
  //       icon: 'error',
  //       title: 'Error',
  //       text: errorMessage,
  //     });
  //   });
  // };

  const GlobalPermissionChecker = (
    expectedCompany,
    // accountAdminPermissions = [],
    projectAdminRoles = []
  ) => {
    const sts = (
      // (getUserCompanyDetails === expectedCompany && userPermission === 'account_admin') ||
      // (getUserCompanyDetails === expectedCompany && userPermission === 'project_admin' && userRoleManual === '') ||
      // (getUserCompanyDetails === expectedCompany && userPermission === 'project_admin' && projectAdminRoles.includes(userRoleManual))

      // (getUserCompanyDetails === expectedCompany && userPermission === 'account_admin') ||
      // (getUserCompanyDetails === expectedCompany && userPermission === 'project_admin' && userRoleManual.length===0) ||
      // (getUserCompanyDetails === expectedCompany && userPermission === 'project_admin' && projectAdminRoles.some(item=>userRoleManual?.includes?.(item)))

      (getUserCompanyDetails === expectedCompany && (userPermission === 'account_admin' || userPermission === 'project_admin')) ||
      (getUserCompanyDetails === expectedCompany && (userPermission === 'account_admin' || userPermission === 'project_admin') && projectAdminRoles.some(item => userRoleManual?.includes?.(item))) ||
      (getUserCompanyDetails !== expectedCompany && (userPermission === 'account_admin' || userPermission === 'project_admin') && projectAdminRoles.some(item => userRoleManual?.includes?.(item)))
    );
    return !sts;
  };


  // const cons_cont_sts = (
  //   expectedCompany,
  //   // accountAdminPermissions = [],
  //   projectAdminRoles = []
  // ) => {
  //   const sts=(
  //     (getUserCompanyDetails === expectedCompany && (userPermission === 'account_admin' || userPermission === 'project_admin')) ||        
  //     projectAdminRoles.some(item=>userRoleManual?.includes?.(item))
  //     // projectAdminRoles.includes(userRoleManual)
  //   );
  //   return sts;
  // };

  const cons_cont_sts = (
    expectedCompany,
    // accountAdminPermissions = [],
    projectAdminRoles = []
  ) => {
    const sts = (
      (getUserCompanyDetails === expectedCompany && proj_access_level === true) ||
      projectAdminRoles.some(item => userRoleManual?.includes?.(item))
      // projectAdminRoles.includes(userRoleManual)
    );
    return sts;
  };



  const openCreateProjectPopup = () => {
    MySwal.fire({
      title: '<h3>Create Project</h3>',
      html: `
        <div class="popup-container">
          <div class="popup-field">
            <label for="projectName">Project Name *</label>
            <input id="projectName" type="text" class="popup-input" placeholder="Enter a project name">
          </div>
  
          <div class="popup-field">
            <label for="projectNumber">Project Number</label>
            <input id="projectNumber" type="text" class="popup-input" placeholder="Enter a project number">
          </div>
  
          <div class="popup-field">
            <label for="account">Account *</label>
            <select id="account" class="popup-select">
              <option value="" disabled selected>Select an account</option>
              <option value="NUS CPMS">NUS CPMS</option>
              <option value="ABC Corporation">ABC Corporation</option>
            </select>
          </div>
  
          <div class="popup-field">
            <label for="projectType">Project Type *</label>
            <select id="projectType" class="popup-select">
              <option value="" disabled selected>Select project type</option>
              <option value="Education Facility">Education Facility</option>
              <option value="Healthcare Facility">Healthcare Facility</option>
            </select>
          </div>
        </div>
      `,
      showCancelButton: true,
      confirmButtonText: 'Create',
      cancelButtonText: 'Cancel',
      focusConfirm: false,
      customClass: {
        popup: 'custom-popup',
      },
      preConfirm: async () => {
        const projectName = document.getElementById('projectName').value;
        const projectNumber = document.getElementById('projectNumber').value;
        const account = document.getElementById('account').value;
        const projectType = document.getElementById('projectType').value;

        // Validation
        if (!projectName || !account || !projectType) {
          Swal.showValidationMessage('Please fill out all required fields');
          return false;
        }

        // Show loading state
        Swal.showLoading();

        const sendData = {
          project_name: projectName,
          project_number: projectNumber,
          account: account,
          project_account: projectType,
        };

        try {
          const response = await queuedApiFetch(`/project/insertprojectdetails`,
            {
              method: 'POST',
              // headers: {
              //   'Content-Type': 'application/json',
              //   'ngrok-skip-browser-warning': '69420',
              // },
              body: JSON.stringify(sendData),
            }
          );
          const result = await response;

          if (result.apistatus.Status_Code === 200 && result.apistatus.Status_Description.toLowerCase() === 'success') {
            showToast.success('Project Created Successfully');
            return true; // Resolves the promise
          } else {
            Swal.showValidationMessage(result.apistatus.Status_Description || 'Error occurred. Please try again.');
            return false; // Rejects the promise
          }
        } catch (error) {
          console.error('Error saving data:', error);
          Swal.showValidationMessage('Something went wrong. Please try again.');
          return false; // Rejects the promise
        }
      },
    }).then((result) => {
      if (result.isConfirmed) {
        console.log('Project created successfully!');
        // Optional: Perform any additional actions after popup closes
      }
    }).catch((error) => {
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: error,
      });
    });
  };

  // const nus_admin_sts=(expectedCompany)=>{
  //       return (getUserCompanyDetails===expectedCompany && (userPermission === 'account_admin' || userPermission === 'project_admin'));
  //     };

  // const nus_admin_sts=(expectedCompany,projectAdminRoles = [])=>{
  //   return ((getUserCompanyDetails===expectedCompany && (userPermission === 'account_admin' || userPermission === 'project_admin')) || (userRoleManual?.length===0 ||
  // projectAdminRoles.some(item=>userRoleManual?.includes?.(item)) ));
  // };

  // const nus_admin_sts=(expectedCompany,projectAdminRoles = [])=>{
  //   return ((getUserCompanyDetails===expectedCompany && (userPermission === 'account_admin' || userPermission === 'project_admin') && userRoleManual?.length===0) ||
  // projectAdminRoles.some(item=>userRoleManual?.includes?.(item)) );
  // };

  const nus_admin_sts = (expectedCompany, projectAdminRoles = []) => {
    return ((getUserCompanyDetails === expectedCompany && proj_access_level === true) ||
      projectAdminRoles.some(item => userRoleManual?.includes?.(item)));
  };

  // const nus_non_admin_sts=()=>{
  //   return (getUserCompanyDetails ==='NUS' && (userPermission !== 'account_admin' || userPermission !== 'project_admin'));
  // };

  // const nus_cons_cont_sts=(expectedCompany, projectAdminRoles = [])=>{
  //   return (getUserCompanyDetails ===expectedCompany && userPermission ==='project_user' && projectAdminRoles.includes(userRoleManual));
  // };

  const nus_cons_cont_sts = (expectedCompany, projectAdminRoles = []) => {
    return (projectAdminRoles.some(item => userRoleManual?.includes?.(item)));
    // return (projectAdminRoles.includes(userRoleManual));
  };

  // const nus_contractor_sts=()=>{
  //   return (getUserCompanyDetails ==='NUS' && (userPermission !== 'account_admin' || userPermission !== 'project_admin'));
  // };

  return (
    <div className="wbshor">
      {loading && <FullscreenLoader />}
      <div className="login-header-wrap">
        <div className="login-header">
          <div className="pagetitle">{projectName ? projectName : 'Project Name'}</div>
          {activeButton === 'SubmitProgressClaim' && (
            <>
              <div className="">Vendor Name: {getUserCompanyDetails}</div>
              <div className="">Submitter Name: {userName}</div>
            </>
          )}


          <div className="button-wrapper">
            <button className="btntopright" id="optionsBtn" onClick={toggleOptions}>
              <FontAwesomeIcon icon={faBars} title="Settings" />
            </button>
            {showOptions && (
              <div className="options-popup" id="optionsPopup" ref={optionsPopupRef} style={{ display: 'flex' }}>
                <button className={`option-btn btn1 ${activeButton === 'ProjectFiles' ? 'active' : ''}`}
                  onClick={() => {
                    const ProjectFilesIframe = `https://acc.autodesk.com/build/files/projects/${defaultProjectNumber}?folderUrn=${urnlist.proj_files}&viewModel=detail&moduleId=folders&${qs_params}`;
                    handleComponentChange(ProjectFilesIframe, 'ProjectFiles'); window.location.replace(ProjectFilesIframe)
                  }}>Project Files</button>
                <button className={`option-btn btn1 ${activeButton === 'Correspondence' ? 'active' : ''}`}
                  disabled={GlobalPermissionChecker("NUS", ['Project Manager (PM)'])}
                  onClick={() => { handleComponentChange(CorrespondenceIframe, 'Correspondence'); window.location.replace(CorrespondenceIframe) }}>Correspondence</button>
                <button className={`option-btn btn1 ${activeButton === 'Meetings' ? 'active' : ''}`}
                  disabled={GlobalPermissionChecker("NUS", ['Project Manager (PM)'])}
                  onClick={() => { handleComponentChange(MeetingsIframe, 'Meetings'); window.location.replace(MeetingsIframe) }}>Meetings</button>
                <button className={`option-btn btn1 ${activeButton === 'Transmittal' ? 'active' : ''}`}
                  onClick={() => { handleComponentChange(TransmittalIframe, 'Transmittal'); window.location.replace(TransmittalIframe) }}>Transmittal</button>
                {/* <button className="option-btn">Transmittal</button> */}
              </div>
            )}

          </div>
        </div>
      </div>

      <div className="container">
        <div className="innerwrap">
          <div className="leftbar">
            {/* Planning Section */}
            {(nus_admin_sts('NUS', ['Project Manager (PM)'])) ? (<>
              <button className={`option-btn btn1 ${activeSub1 == 0 ? 'active' : ''}`} onClick={() => toggleSub1(0)}>
                <span><strong>Planning</strong></span> <i>▼</i>
              </button>

              {activeSub1 === 0 && (
                <div className="sub1 active">
                  {/* <button
                  className={`sub-btn ${activeButton === 'InitiateNewProject' ? 'active' : ''}`}
                  onClick={openCreateProjectPopup}
                >
                  Initiate New Project
                </button> */}

                  <button
                    className={`sub-btn ${activeButton === 'updateProjectDetails' ? 'active' : ''}`}
                    onClick={() => { handleComponentChange('', 'updateProjectDetails'); }}
                  // disabled={GlobalPermissionChecker("NUS",['Project Manager (PM)'])}
                  >
                    Project Details
                  </button>
                  <button
                    className={`sub-btn ${activeButton === 'InitiateCPRS' ? 'active' : ''}`}
                    onClick={() => {
                      handleComponentChange(InitiateCPRSIframe, 'InitiateCPRS');
                      cprsPopup()
                    }}
                  // disabled={(userPermission !== 'account_admin' || userPermission !== 'project_admin') && getUserCompanyDetails !== 'NUS'} 
                  // disabled={GlobalPermissionChecker("NUS",['Project Manager (PM)'])}
                  >
                    Initiate CPRS
                  </button>
                  {/* {((userPermission === 'project_admin' || userPermission === 'account_admin') && getUserCompanyDetails === 'NUS') ? (
                <button
                  className={`sub-btn ${activeButton === 'InitiateCPRS' ? 'active' : ''}`}
                  onClick={() => { 
                  handleComponentChange(InitiateCPRSIframe, 'InitiateCPRS'); 
                    cprsPopup() 
                  }}>
                  Initiate CPRS
                </button>
                ):null}  */}
                </div>
              )}

            </>) : null}

            {/* Procurement Consultant Section */}
            {(nus_admin_sts('NUS', ['Project Manager (PM)', 'Admin & Contract (AC)'])) ? (<>
              <button className={`option-btn btn1 ${activeSub1 == 1 ? 'active' : ''}`} onClick={() => toggleSub1(1)}>
                <span>Procurement Consultant</span> <i>▼</i>
              </button>

              {activeSub1 === 1 && (
                <div className="sub1 active">
                  <button className={`sub-btn ${activeButton === 'ConsultantProcurementRequest' ? 'active' : ''}`}
                    // disabled={(userPermission !== 'account_admin' || userPermission !== 'project_admin') && getUserCompanyDetails !== 'NUS'} 
                    style={{ display: nus_admin_sts("NUS", ['Project Manager (PM)']) ? 'block' : 'none' }}
                    onClick={() => handleComponentChange('', 'ConsultantProcurementRequest')} >
                    Procurement Request
                  </button>
                  {/* onClick={openPopup} */}
                  <button
                    className={`sub-btn ${activeButton === 'ConsultantCreateContract' ? 'active' : ''}`}
                    // style={{ display: nus_admin_sts("NUS", ['Admin & Contract (AC)']) ? 'block' : 'none' }}
                    style={{ display: ( (getUserCompanyDetails ==='NUS' && userPermission === 'account_admin') || nus_admin_sts("NUS", ['Admin & Contract (AC)'])) ? 'block' : 'none' }}
                    onClick={() => { handleComponentChange(ConsultantCreateContractIframe, 'ConsultantCreateContract'); }} //window.location.replace(ConsultantCreateContractIframe)
                  >
                    Create Contract
                  </button>
                </div>
              )}

            </>) : null}

            {/* Design Development Section */}
            {(nus_admin_sts('NUS', ['Project Manager (PM)', 'Admin', 'Consultant']) || nus_cons_cont_sts('NUS', ['Consultant'])) ? (<>
              <button className={`option-btn btn1 ${activeSub1 == 2 ? 'active' : ''}`} onClick={() => toggleSub1(2)}>
                <span>Design Development</span> <i>▼</i>
              </button>


              {activeSub1 === 2 && (
                <div className="sub1 active">
                  <button
                    className={`sub-btn ${activeButton === 'DesignSubmittal' ? 'active' : ''}`}
                    style={{ display: cons_cont_sts("NUS", ['Consultant']) ? 'block' : 'none' }}
                    onClick={() => { handleComponentChange(DesignSubmittalIframe, 'DesignSubmittal'); window.location.replace(DesignSubmittalIframe) }}
                  // disabled={GlobalPermissionChecker("NUS",['Consultant'])}
                  >
                    Design Submittal
                  </button>
                  <button
                    className={`sub-btn ${activeButton === 'DesignReview' ? 'active' : ''}`}
                    style={{ display: cons_cont_sts("NUS", ['Project Manager (PM)']) ? 'block' : 'none' }}
                    onClick={() => { handleComponentChange(DesignReviewIframe, 'DesignReview'); designReviewPopup() }}
                  // disabled={GlobalPermissionChecker("NUS",['Project Manager (PM)'])}
                  >
                    Design Review
                  </button>
                  <button
                    className="sub-btn"
                    style={{ display: cons_cont_sts("NUS", ['Consultant', 'Project Manager (PM)']) ? 'block' : 'none' }}
                    onClick={() => toggleSub2(0)}>
                    <span>Estimated Cost Approval</span> <i>▼</i>
                  </button>
                  {activeSub2 === 0 && (
                    <div className="sub2 active">
                      <button
                        className={`sub-btn ${activeButton === 'RequestApproval' ? 'active' : ''}`}
                        // disabled={GlobalPermissionChecker("NUS",['Consultant QS'])}
                        style={{ display: cons_cont_sts("NUS", ['Consultant']) ? 'block' : 'none' }}
                        onClick={() => { handleComponentChange(RequestApprovalIframe, 'RequestApproval'); window.submitform(t_req_approval, formData, 'Design Development_Estimated Cost Approval_Request Approval'); }}
                      >
                        {/* window.location.replace(RequestApprovalIframe) */}
                        Request Approval
                      </button>
                      <button
                        className={`sub-btn ${activeButton === 'UpdateContract' ? 'active' : ''}`}
                        // disabled={GlobalPermissionChecker("NUS",['Project Manager (PM)'])}
                        style={{ display: cons_cont_sts("NUS", ['Project Manager (PM)']) ? 'block' : 'none' }}
                        onClick={() => { handleComponentChange(UpdateContractIframe, 'UpdateContract'); window.location.replace(UpdateContractIframe) }}
                      >
                        Update Contract
                      </button>
                    </div>
                  )}
                </div>
              )}

            </>) : null}

            {/* Authority Submissions */}
            {(nus_admin_sts('NUS', ['Consultant'])) ? (<>
              <button className={`option-btn btn1 ${activeSub1 === 7 ? 'active' : ''}`}
                onClick={() => {
                  const AuthoritySubmission = `https://acc.autodesk.com/docs/files/projects/${defaultProjectNumber}?folderUrn=${urnlist.auth_submsn}&viewModel=detail&moduleId=folders&${qs_params}&menu=authoritysubmission`;
                  window.location.replace(AuthoritySubmission);
                  toggleSub1(7)
                }}>
                <span> Authority Submission</span>
              </button>
            </>) : null}


            {/* Procurement Contractor Section */}
            {(nus_admin_sts('NUS', ['Project Manager (PM)', 'Admin'])) ? (<>

              <button className={`option-btn btn1 ${activeSub1 == 3 ? 'active' : ''}`} onClick={() => toggleSub1(3)}>
                <span>Procurement Contractor</span> <i>▼</i>
              </button>

              {activeSub1 === 3 && (
                <div className="sub1 active">
                  <button className={`sub-btn ${activeButton === 'ContractProcurementRequest' ? 'active' : ''}`}
                    // disabled={(userPermission !== 'account_admin' || userPermission !== 'project_admin') && getUserCompanyDetails !== 'NUS'} 
                    style={{ display: nus_admin_sts("NUS", ['Project Manager (PM)']) ? 'block' : 'none' }}
                    onClick={() => handleComponentChange('', 'ContractProcurementRequest')} >Procurement Request</button>
                  {/* onClick={openProcurementContractor} */}
                  <button
                    className={`sub-btn ${activeButton === 'ContractorCreateContract' ? 'active' : ''}`}
                    // disabled={(userPermission !== 'account_admin' || userPermission !== 'project_admin') && getUserCompanyDetails !== 'NUS'} 
                    // disabled={GlobalPermissionChecker("NUS",['Admin & Contract (AC)'])}
                    style={{ display: nus_admin_sts("NUS", ['Admin & Contract (AC)']) ? 'block' : 'none' }}
                    onClick={() => { handleComponentChange(ContractorCreateContractIframe, 'ContractorCreateContract'); }}  //window.location.replace(ContractorCreateContractIframe)
                  >
                    Create Contract
                  </button>
                </div>
              )}

            </>) : null}

            {/* Construction Section */}
            {(nus_admin_sts('NUS', ['Project Manager (PM)']) || nus_cons_cont_sts('NUS', ['Consultant', 'Contractor'])) ? (<>
              <button className={`option-btn btn1 ${activeSub1 == 4 ? 'active' : ''}`} onClick={() => toggleSub1(4)}>
                <span>Construction</span> <i>▼</i>
              </button>


              {activeSub1 === 4 && (
                <div className="sub1 active">
                  <button className="sub-btn"
                    style={{ display: cons_cont_sts("NUS", ['Project Manager (PM)']) ? 'block' : 'none' }}
                    onClick={() => toggleSub2(1)}>
                    <span>Project Commencement</span> <i>▼</i>
                  </button>
                  {activeSub2 === 1 && (
                    <div className="sub2 active">
                      <button
                        className={`sub-btn ${activeButton === 'CommencementForm' ? 'active' : ''}`}
                        onClick={() => { handleComponentChange(CommencementFormIframe, 'CommencementForm'); window.submitform(t_proj_comncmnt, formData, 'Construction_Project Commencement_Commencement Form'); }}
                      >
                        {/* window.location.replace(CommencementFormIframe) */}
                        Commencement Form
                      </button>
                    </div>
                  )}

                  <button
                    className={`sub-btn ${activeButton === 'SubmitDocumentsRequest' ? 'active' : ''}`}
                    onClick={() => handleComponentChange(SubmitDocumentsRequestIframe, 'SubmitDocumentsRequest')}
                  >
                    Submit Documents/Request
                  </button>
                  <button
                    className={`sub-btn ${activeButton === 'ConstructionSubmittal' ? 'active' : ''}`}
                    onClick={() => { handleComponentChange(ConstructionSubmittalIframe, 'ConstructionSubmittal'); window.location.replace(ConstructionSubmittalIframe) }}
                  >
                    Construction submittal
                  </button>

                  {/*<button className="sub-btn" 
                style={{ display: cons_cont_sts("NUS",['Consultant','Contractor']) ? 'block': 'none' }}
                onClick={() => toggleSub2(3)}>
                  <span>Progress claims</span> <i>▼</i>
                </button>
                {activeSub2 === 3 && (
                  <div className="sub2 active">
                    <button
                      className={`sub-btn ${activeButton === 'ConsultantApproval' ? 'active' : ''}`}
                      style={{ display: cons_cont_sts("NUS",['Contractor']) ? 'block': 'none' }}
                      onClick={() => { handleComponentChange(ConsultantApprovalIframe, 'ConsultantApproval');window.submitform(t_consult_appr,formData,'Construction_Progress claims_Consultant Approval');  }}
                    >
                      Consultant Approval
                    </button>

                    <button
                      className={`sub-btn ${activeButton === 'SubmitProgressClaim' ? 'active' : ''}`}
                      style={{ display: cons_cont_sts("NUS",['Consultant','Contractor']) ? 'block': 'none' }}
                      onClick={() => handleComponentChange(SubmitProgressClaimIframe, 'SubmitProgressClaim')}
                    >
                      Submit Progress claim
                    </button>

                    <button
                    className={`sub-btn ${activeButton === 'InitiatePayment' ? 'active' : ''}`}
                    style={{ display: cons_cont_sts("NUS",['Others']) ? 'block': 'none' }}
                    // disabled={GlobalPermissionChecker("NUS",['Admin & Contract (AC)','Project Manager (PM)','Admin'])}
                    onClick={() => handleComponentChange(InitiatePaymentIframe, 'InitiatePayment')}
                  >
                    Initiate Payment
                  </button>

                  </div>
                )}*/}

                  <button className="sub-btn"
                    style={{ display: cons_cont_sts("NUS", ['Consultant', 'Project Manager (PM)']) ? 'block' : 'none' }}
                    onClick={() => toggleSub2(2)}>
                    <span>Submit RVW</span> <i>▼</i>
                  </button>
                  {activeSub2 === 2 && (
                    <div className="sub2 active">
                      <button
                        className={`sub-btn ${activeButton === 'ApplyForRVW' ? 'active' : ''}`}
                        style={{ display: cons_cont_sts("NUS", ['Consultant']) ? 'block' : 'none' }}
                        onClick={() => handleComponentChange(ApplyForRVWIframe, 'ApplyForRVW')}
                      >
                        Apply for RVW
                      </button>
                      <button
                        className={`sub-btn`}
                        style={{ display: cons_cont_sts("NUS", ['Project Manager (PM)']) ? 'block' : 'none' }}
                        onClick={() => window.location.href = `https://acc.autodesk.com/cost/changeorder/projects/${defaultProjectNumber}/changeorders/pco?${qs_params}&menu=Contract Variation`}
                      >
                        Contract Variation
                      </button>

                      {/* <button
                  className={`sub-btn ${activeButton === 'ContractVariation' ? 'active' : ''}`}
                  onClick={() => handleComponentChange(ContractVariationIframe, 'ContractVariation')}
                >
                  Contract Variation
                </button> */}
                    </div>
                  )}
                </div>
              )}

            </>) : null}

            {/* Handover Section */}
            {(nus_admin_sts('NUS', ['Consultant', 'Contractor', 'Project Manager (PM)'])) ? (<>
              <button className={`option-btn btn1 ${activeSub1 == 5 ? 'active' : ''}`} onClick={() => toggleSub1(5)}>
                <span>Handover</span> <i>▼</i>
              </button>


              {activeSub1 === 5 && (
                <div className="sub1 active">
                  <button
                    className={`sub-btn ${activeButton === 'GenerateDefectList' ? 'active' : ''}`}

                    style={{ display: cons_cont_sts("NUS", ['Contractor']) ? 'block' : 'none' }}
                    onClick={() => { handleComponentChange(GenerateDefectListIframe, 'GenerateDefectList'); window.location.replace(GenerateDefectListIframe) }}
                  >
                    Generate defect list
                  </button>

                  <button
                    className={`sub-btn ${activeButton === 'CertOfSubstantialCompletion' ? 'active' : ''}`}
                    style={{ display: cons_cont_sts("NUS", ['Consultant']) ? 'block' : 'none' }}
                    onClick={() => { handleComponentChange('', 'CertOfSubstantialCompletion'); subsCompletionPopup() }}
                  >
                    Cert of Substantial Completion
                  </button>

                  <button
                    className={`sub-btn ${activeButton === 'FinalCompletionCert' ? 'active' : ''}`}
                    style={{ display: cons_cont_sts("NUS", ['Consultant']) ? 'block' : 'none' }}
                    onClick={() => { handleComponentChange('', 'FinalCompletionCert'); finalCompletionPopup() }}
                  >
                    Final Completion Cert
                  </button>


                  <button
                    className={`sub-btn ${activeButton === 'WarrantyAsbuiltOM' ? 'active' : ''}`}
                    style={{ display: cons_cont_sts("NUS", ['Contractor']) ? 'block' : 'none' }}
                    onClick={() => { handleComponentChange('', 'WarrantyAsbuiltOM'); warrantyPopup() }}
                  >
                    Warranty/Asbuilt/OM
                  </button>

                  <button
                    className={`sub-btn ${activeButton === 'HandoverForm' ? 'active' : ''}`}
                    style={{ display: cons_cont_sts("NUS", ['Project Manager (PM)']) ? 'block' : 'none' }}
                    onClick={() => { handleComponentChange(HandoverFormIframe, 'HandoverForm'); window.submitform(t_ho_form, formData, 'Handover_Handover Form'); }}
                  >
                    {/* window.location.replace(HandoverFormIframe) */}
                    Handover Form
                  </button>

                  {/* <button
                  className={`sub-btn ${activeButton === 'InitiateHandover' ? 'active' : ''}`}
                  onClick={() => handleComponentChange(InitiateHandoverIframe, 'InitiateHandover')}
                >
                  Initiate handover
                </button> */}

                </div>
              )}

            </>) : null}

            {/* Post Construction Section */}
            {(nus_admin_sts('NUS', ['Project Manager (PM)', 'Consultant']) || nus_cons_cont_sts('NUS', ['Consultant'])) ? (<>
              <button className={`option-btn btn1 ${activeSub1 == 6 ? 'active' : ''}`} onClick={() => toggleSub1(6)}>
                <span>Post Construction</span> <i>▼</i>
              </button>


              {activeSub1 === 6 && (
                <div className="sub1 active">
                  <button
                    className={`sub-btn ${activeButton === 'SubmitForm' ? 'active' : ''}`}
                    style={{ display: cons_cont_sts("NUS", ['Consultant']) ? 'block' : 'none' }}
                    onClick={() => handleComponentChange(SubmitFormIframe, 'SubmitForm')}
                  >
                    Submit Form
                  </button>
                  <button
                    className={`sub-btn ${activeButton === 'CloseProject' ? 'active' : ''}`}
                    style={{ display: cons_cont_sts("NUS", ['Project Manager (PM)']) ? 'block' : 'none' }}
                    onClick={() => { handleComponentChange(CloseProjectIframe, 'CloseProject'); window.submitform(t_close_project, formData, 'Post Construction_Close Project'); }}
                  >
                    {/* window.location.replace(CloseProjectIframe) */}
                    Close Project
                  </button>
                </div>
              )}

            </>) : null}
          </div>

          {currentComponent}
          {change}
        </div>
      </div>
    </div>
  );
}

export default Plans;